import { render, staticRenderFns } from "./SettingsSelectGroup.vue?vue&type=template&id=2d4f01d6"
import script from "./SettingsSelectGroup.vue?vue&type=script&lang=js"
export * from "./SettingsSelectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports